<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.customer.actions.sendWelcomeEmail.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'warning', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Customer } from '~/_api/models/customer'

interface Props {
  customer: Customer
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()

const info = computed(() => {
  return $i18n.t('components.customer.actions.sendWelcomeEmail.info', { name: props.customer.displayName, id: props.customer.idCustomer })
})

const open = () => {
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.customer.resendWelcomeEmail(props.customer.idCustomer.toString())

    if (response.success) {
      $notification.toast({
        title: $i18n.t('components.customer.actions.sendWelcomeEmail.success'),
        text: $i18n.t('components.customer.actions.sendWelcomeEmail.successInfo', { name: props.customer.displayName }),
      })

      emit('success')
      emit('update:loading', false)

      return response
    }
  } catch (e) {
    console.log(e)
  }

  emit('update:loading', false)
}

defineExpose({ open })
</script>
